var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"loading":_vm.loading || _vm.getUserFb && _vm.getUserFb.token && true,"type":"facebook","icon":"facebook","title":_vm.getUserStatus == 'unknown' ? 'Entrar com Facebook' :
          _vm.getUserStatus == 'connected' ? 'Por favor, complete seus dados.' :
          _vm.getUserStatus == 'not_authorized' ? 'Não autorizado' : 'Entrar com Facebook'},on:{"click":_vm.clickFacebook}})
}
var staticRenderFns = []

export { render, staticRenderFns }